import { Badge } from '@change/ds-core-ui';
import { StarIcon } from '@change/ds-icons';

import { ActionButton } from './components/ActionButton';
import { TaskDetails } from './components/TaskDetails';

type Translate = (key: string) => string;

export const getPrimaryActionText = (featureKey: string | null, translate: Translate): string => {
	return featureKey === 'update_decision_maker'
		? translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.task.update_decision_maker_action')
		: translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.task.take_action');
};

export const renderStartBadge = (translate: Translate) => (
	<Badge
		className="self-start"
		variant="information"
		emphasis="weaker"
		size="small"
		label={translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.task.start_here_badge')}
		leadingIcon={<StarIcon className="text-icon-information !size-4" svgClassName="!size-4" />}
		data-qa="dynamic-task-start-here-badge"
	/>
);

export const renderExpandedContent = (
	description: readonly string[],
	reasoning: string | null,
	isFirstActive: boolean,
	primaryActionText: string,
) => (
	<>
		<TaskDetails description={description} reasoning={reasoning} />
		<div className="mt-4 md:hidden">
			<ActionButton
				isFirstActive={isFirstActive}
				primaryActionText={primaryActionText}
				className="w-full"
				dataQaSuffix="-mobile"
			/>
		</div>
	</>
);
